/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-23 16:32:50
 * @LastEditTime: 2025-04-14 09:11:36
 * @LastEditors: ywj@originqc.com
 */

import official from './imgs/official.svg';
import express from './imgs/express.svg';
import kf from './imgs/kf.svg';
import sales from './imgs/sales.svg';
export const serviceData = [
  {
    id: 1,
    pic: official,
    name: '官方品质保证'
  },
  {
    id: 2,
    pic: express,
    name: '快递直达，免费包邮'
  },
  {
    id: 3,
    pic: kf,
    name: '人工客服 专属服务'
  },
  {
    id: 4,
    pic: sales,
    name: '官方售后 预约维修'
  },
];

export const footerContent = [
  {
    title: '购物指南',
    children: [
      {
        title: '帮助中心',
        link: ''
      },
      {
        title: '常见问题',
        link: ''
      },
    ]
  },
  {
    title: '支付方式',
    children: [
      {
        title: '在线支付',
        link: ''
      },
      {
        title: '付款开票',
        link: ''
      },
    ]
  },
  {
    title: '服务政策',
    children: [
      // {
      //   title: '售后服务',
      //   link: ''
      // },
      {
        title: '隐私政策',
        link: 'https://show.originqc.com.cn/prod/quantum_cloud/webAppAssetsFiles/assets/files/pdf/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf'
      },
    ]
  },
  {
    title: '关于我们',
    children: [
      {
        title: '公司介绍',
        link: 'https://originqc.com.cn/zh/about.html'
      },
      {
        title: '联系我们',
        link: 'https://contact.originqc.com.cn/'
      },
      {
        title: '加入我们',
        link: 'https://originqc.com.cn/zh/join.html'
      },
    ]
  },
];
export const footerContact = 
  {
    subTitle: '量子计算机工程用品/算法软件服务平台',
    time: '工作时间：周一到周五 9:00-18:00',
    tel:'400-680-9696'
  }
